module.exports = __webpack_public_path__ + "static/media/3rdParty.89c5a695.svg";